export default __webpack_public_path__ + "static/media/metrologie.aa5985cd.jpg";